import { gql } from '@apollo/client';

export const CB_COMPANY_PREFERENCES_FIELDS = gql`
  fragment CbCompanyPreferencesFields on CbCompanyPreferences {
    id
    userId
    teamId
    sports
    budgetRanges
    perTalentBudgetRanges
    marketingChannels
    smPlatforms
    audienceGender
    audienceAgeRanges
    audienceEthnicities
    audienceInterests
    audienceLanguages
    audienceLocations {
      country
      state
      city
      placeId
      placeText
      latitude
      longitude
    }
  }
`;

/**
 * Admins name the brand explicitly; every other caller has it filled in from
 * their own CB context.
 */
export const GET_CB_COMPANY_PREFERENCES = gql`
  query GetCbCompanyPreferences($input: GetCbCompanyPreferencesInput!) {
    getCbCompanyPreferences(input: $input) {
      ...CbCompanyPreferencesFields
    }
  }
  ${CB_COMPANY_PREFERENCES_FIELDS}
`;
